/*
 * Public API Surface of ng-image-as-particles
 */

export * from './lib/ng-image-as-particles.service';
export * from './lib/ng-image-as-particles.component';
export * from './lib/ng-image-as-particles.module';
